/**
 * Application metadata configuration
 *
 * This file contains user-configurable metadata that can be changed
 * without modifying UI components.
 */

/**
 * Status text displayed alongside the version number.
 * Change this as the application progresses through development phases.
 *
 * Examples:
 *   - "Validation Testing In Progress"
 *   - "Beta"
 *   - "Release Candidate"
 *   - "" (empty string to hide status)
 */
export const APP_STATUS = "Validation Testing In Progress";
